
function geoRedirectDeny(data, geoRedirectModal,event) {
    docCookies.setItem('redirectpermission', 'deny', 2629746, '/');
    // possibly redirect to other language for the current country
    if (data.denyRedirectUrl) {
        window.location.href = data.denyRedirectUrl;
    }
    else {
        geoRedirectModal.close(event);
    }

}

function geoRedirectAccept(data) {
    if (data.redirectUrl) {
        docCookies.setItem('redirectpermission', 'accept', 2629746, '/');
        // redirect to other country
        window.location.href = data.redirectUrl;
    }
}

(function geoRedirect() {

  fetch(`/api/georedirect/?url=${encodeURIComponent(window.location.href)
  }&browserLanguage=${encodeURIComponent(navigator.language || navigator.userLanguage)}`, {
    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': document.documentElement.lang,
      'X-Requested-With': 'XMLHttpRequest'
    },
    credentials: 'same-origin',
  }).then(response => response.json()).then((data) => {
    if (data) {
      if (data.popupHtml) {

        const geoRedirectModalHtml = document.createElement('div');
        geoRedirectModalHtml.className = 'modal modal--bottom modal--small modal--static';
        geoRedirectModalHtml.innerHTML = `
            <div class="modal__body">
                ${website.concept === 'hh' ? '<img src="/Content/images/hh/hh-logo'+(navigator.language.indexOf('fr') > -1 ? '-fr' : '')+'.png" alt="" class="modal__logo header__logo__icon" />'
                                           : '<svg class="modal__logo header__logo__icon"><use xlink:href="#logo-'+website.concept+'"></use></svg>'}
                <h2 class="modal__header__title heading-2 heading-2--light">${data.popupHtml}</h2>
                <button class="button button--dark" data-geo-accept>${data.yesButtonHtml}</button>
                <button class="button button--dark" data-geo-deny>${data.noButtonHtml}</button>
            </div>`;
        document.body.appendChild(geoRedirectModalHtml);

        const geoAcceptButton = document.querySelector('[data-geo-accept]');
        const geoAcceptDeny = document.querySelector('[data-geo-deny]');

        const geoRedirectModal = new Modal(geoRedirectModalHtml);

        geoAcceptButton.addEventListener('click', () => {
            geoRedirectAccept(data);
        });

        geoAcceptDeny.addEventListener('click', (event) => {
            geoRedirectDeny(data, geoRedirectModal,event);
        });


        geoRedirectModal.open();

      } else if (data.redirectUrl) {
        // possibly redirect to other language for the same country
        // or possibly redirect to other country for .com or .ch domain
        window.location.href = data.redirectUrl;
      }
    }
  });
}());
